import React from "react";

import "./BookNow.css";
import { Link } from "react-router-dom";
function BookNow({backgroundColor,heading, paragraph, buttonText, imageAlt,backgroundButtonColor,link}) {
    const containerStyle = {
        background: backgroundColor , 

      };
      const buttonStyle = {
        background: backgroundButtonColor,
      };
    
  return (
    
    <div
      className="BookNow"
      style={containerStyle}
    >

      <div className="BookNow-Order">
      <Link to={link}  style={{textDecoration:"none"}}>
        <h4 style={{color:'#000'}}>{heading}</h4>
        <p>
          {paragraph}
        </p>
        <button style={buttonStyle}>{buttonText}</button>
        </Link>
      </div>
      <div>
        <img src={imageAlt} alt="book" />
      </div>
      
    </div>
 
  );
}

export default BookNow;
